export const columns = [
  {
    title: '编号',
    width: '65px',
    dataIndex: 'id',
  },
  {
    title: '任务名称',
    dataIndex: 'work_plan_title',
    scopedSlots: { customRender: 'work_plan_title' },
  },
  {
    title: '推广项目',
    width: '140px',
    dataIndex: 'service_title',
  },
  {
    title: '任务数量',
    width: '100px',
    dataIndex: 'plan_num',
  },
  {
    title: '已提交',
    width: '90px',
    dataIndex: 'create_num',
  },
  {
    title: '已通过',
    width: '90px',
    dataIndex: 'pass_num',

  },
  {
    title: '任务金额',
    width: '120px',
    dataIndex: 'total_money',
  },
  {
    title: '开始日期',
    width: '125px',
    dataIndex: 'plan_start_time',
  },
  {
    title: '结束日期',
    width: '125px',
    dataIndex: 'plan_end_time',
  },
  {
    title: '任务状态',
    dataIndex: 'status',
    width: '100px',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: '200px',
  },
];
export const columns1 = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '医疗机构',
    dataIndex: 'work_plan_title',
  },
  {
    title: '拜访科室',
    dataIndex: 'service_title',
  },
  {
    title: '医生姓名',
    dataIndex: 'plan_num',
  },
  {
    title: '拜访时间',
    dataIndex: 'total_money',
  },
  {
    title: '拜访目的',
    dataIndex: 'plan_start_time',
  },
  {
    title: '关注点',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '拜访结果',
    dataIndex: 'plan_start_time',
  },
  {
    title: '拜访次数',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '物料名称',
    dataIndex: 'plan_start_time',
  },
  {
    title: '定位',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '图片',
    dataIndex: 'plan_start_time',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const formData2 = [
  {
    name: 'name',
    lable: '',
    lableCol: 0,
    wrapperCol: 24,
    offset: 0,
    span: 24,
  },
];

export const columns2 = [
  {
    title: '序号',
    width: '65px',
    dataIndex: 'id',
    // customRender: (text, record, index) => index + 1,
  },
  {
    title: '开始时间',
    width: '170px',
    dataIndex: 'task_submit_time',
  },
  {
    title: '使用资料',
    width: '280px',
    dataIndex: 'task_docment_name',
    scopedSlots: { customRender: 'task_docment_name' },
  },
  {
    title: '客户/地址',
    dataIndex: 'sign_address',
    // width: '360px',
    scopedSlots: { customRender: 'sign_address' },
  },
  {
    title: '报告状态',
    dataIndex: 'status',
    width: '90px',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '200px',
    scopedSlots: { customRender: 'operation' },
  }
];